export function subdomainReducer(state: string): string {
  return state || 'www';
}
